export default __webpack_public_path__ + "img/64de7ae42c70c505318e8a1d2db88765.svg";